// src/components/Item/AssignStockForm.js

import React, { useMemo, useState } from "react";
import styles from "./AssignStockForm.module.css";
import { typeLabels, matchesSearch } from "../../utils/items";

const isAssignedTo = (user, itemId) =>
  (user.assignedItems || []).some(
    (ai) => ai.item?._id === itemId || ai.item === itemId
  );

/**
 * Admin "Şehre Ata" => bir ürünü seçilen şehirlere (veya tümüne) atar.
 * count=0 sabit (admin stok girmez).
 */
const AssignStockForm = ({ users, items, onAssign }) => {
  const [itemSearch, setItemSearch] = useState("");
  const [itemId, setItemId] = useState("");
  const [selectedUserIds, setSelectedUserIds] = useState([]);

  const filteredItems = useMemo(
    () => (items || []).filter((it) => matchesSearch(it.name, itemSearch)),
    [items, itemSearch]
  );

  // Seçili ürün henüz atanmamış şehirler seçilebilir
  const assignableUsers = users.filter((u) => !itemId || !isAssignedTo(u, itemId));
  const allSelected =
    assignableUsers.length > 0 &&
    assignableUsers.every((u) => selectedUserIds.includes(u._id));

  const toggleUser = (userId) => {
    setSelectedUserIds((prev) =>
      prev.includes(userId) ? prev.filter((id) => id !== userId) : [...prev, userId]
    );
  };

  const toggleAll = () => {
    setSelectedUserIds(allSelected ? [] : assignableUsers.map((u) => u._id));
  };

  const handleItemChange = (newItemId) => {
    setItemId(newItemId);
    // Bu üründe zaten atanmış şehirleri seçimden çıkar
    setSelectedUserIds((prev) =>
      prev.filter((id) => {
        const user = users.find((u) => u._id === id);
        return user && !isAssignedTo(user, newItemId);
      })
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!itemId) {
      alert("Lütfen bir ürün seçiniz.");
      return;
    }
    if (selectedUserIds.length === 0) {
      alert("Lütfen en az bir şehir seçiniz.");
      return;
    }
    onAssign(itemId, selectedUserIds);
  };

  return (
    <form onSubmit={handleSubmit} className={styles.form}>
      <label>Ürün Seç</label>
      <input
        type="text"
        placeholder="Ürün ara..."
        value={itemSearch}
        onChange={(e) => setItemSearch(e.target.value)}
        className={styles.searchInput}
      />
      {/* <select size> tek sonuçta tıklamayı iletmediği için tıklanabilir liste */}
      <div className={styles.itemList} role="listbox" aria-label="Ürünler">
        {filteredItems.map((it) => (
          <button
            type="button"
            role="option"
            aria-selected={it._id === itemId}
            key={it._id}
            className={`${styles.itemOption} ${
              it._id === itemId ? styles.itemOptionSelected : ""
            }`}
            onClick={() => handleItemChange(it._id)}
          >
            {it.name} ({typeLabels[it.type] || it.type})
          </button>
        ))}
      </div>
      {filteredItems.length === 0 && (
        <span className={styles.hint}>Aramaya uygun ürün yok</span>
      )}

      <div className={styles.cityHeader}>
        <label>Şehir Seç</label>
        <button type="button" className={styles.linkButton} onClick={toggleAll}>
          {allSelected ? "Seçimi kaldır" : "Tüm şehirleri seç"}
        </button>
      </div>
      <div className={styles.cityList}>
        {users.map((u) => {
          const already = itemId && isAssignedTo(u, itemId);
          return (
            <label
              key={u._id}
              className={`${styles.cityOption} ${already ? styles.cityAssigned : ""}`}
            >
              <input
                type="checkbox"
                checked={already || selectedUserIds.includes(u._id)}
                disabled={already}
                onChange={() => toggleUser(u._id)}
              />
              {u.name}
              {already && <span className={styles.hint}> (zaten atanmış)</span>}
            </label>
          );
        })}
      </div>

      <button type="submit" className={styles.saveBtn}>
        {selectedUserIds.length > 1
          ? `${selectedUserIds.length} şehre ata`
          : "Ata"}
      </button>
    </form>
  );
};

export default AssignStockForm;
